import { colors } from 'ui/theme';
import { PredictiveGoalsIllustration } from 'ui/illustrations';
import { useCoreGoalsContext } from 'modules/predictiveGoals/components/contexts/CoreGoalsContext/CoreGoalsContext';
import { hasReachedMaxGoalLimit } from 'modules/predictiveGoals/utils';
import { PredictiveGoalsTemplatesSelections } from '../templates/ExistingTemplate/TemplatesSelections';
import { PredictiveGoalsTable } from './PredictiveGoalsTable';
import { ContentUnavailable } from '../ContentUnavailable';
import { isVocabularyEmpty } from '../../goalUtils';
import {
  PREDICTIVE_GOALS_PAGE_INFO_HEADER_TEXT,
  PREDICTIVE_GOALS_PAGE_INFO_TEXT,
  PROJECT_VOCABULARY_NOT_READY_HEADER,
} from '../../constants';
import {
  IndexContentLayout,
  InfoContainer,
  InfoHeader,
  InfoIllustrationContainer,
  InfoText,
  InfoTextContainer,
  MainLayoutWrapper,
  PredictiveGoalsSpacedCard,
  StyledFullWidth,
} from '../Styled';

const PredictiveGoalsPage = () => {
  const {
    goals: { goalData, retrigger: refetchGoals },
    vocab: { vocabData },
    isError: isCoreDataError,
    isLoading: isCoreDataLoading,
  } = useCoreGoalsContext();

  const isDataUnavailable = isVocabularyEmpty(vocabData);
  const isAtGoalLimit = hasReachedMaxGoalLimit(goalData);
  const shouldShowTemplates = !isDataUnavailable;
  return (
    <>
      <StyledFullWidth data-test="predictive-goals-page">
        <MainLayoutWrapper data-background-color={colors.backgroundSecondary}>
          <IndexContentLayout>
            {shouldShowTemplates && (
              <PredictiveGoalsTemplatesSelections isAtGoalLimit={isAtGoalLimit} />
            )}
            {
              // NOTE: Remove this component when templates FF code removed
              !shouldShowTemplates && (
                <PredictiveGoalsSpacedCard shouldHover={false}>
                  <InfoContainer>
                    <InfoTextContainer>
                      <InfoHeader>{PREDICTIVE_GOALS_PAGE_INFO_HEADER_TEXT}</InfoHeader>
                      <InfoText>{PREDICTIVE_GOALS_PAGE_INFO_TEXT}</InfoText>
                    </InfoTextContainer>
                    <InfoIllustrationContainer>
                      <PredictiveGoalsIllustration />
                    </InfoIllustrationContainer>
                  </InfoContainer>
                </PredictiveGoalsSpacedCard>
              )
            }
            <ContentUnavailable
              headerMessage={PROJECT_VOCABULARY_NOT_READY_HEADER}
              showPlaceholderContent={isDataUnavailable}
            >
              <PredictiveGoalsTable
                error={isCoreDataError}
                loading={isCoreDataLoading}
                onMutation={refetchGoals}
                rows={goalData}
                showPlaceholderContent={isDataUnavailable}
              />
            </ContentUnavailable>
          </IndexContentLayout>
        </MainLayoutWrapper>
      </StyledFullWidth>
    </>
  );
};

export default PredictiveGoalsPage;
